import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { DataTable } from "../../../../../../../components/DataTable";
import * as React from "react";
import { useMemo } from "react";
import { translateSubElementString } from "../../../../../../../utils";

function ReviewDataModal({ isOpen, onClose, dataAttribute, gridHeader, data }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage.scopeThree.reviewDataModal"
  });

  const columns = useMemo(() => [
    {
      header: gridHeader,
      accessorKey: dataAttribute,
      size: 200
    },
    {
      header: translateSubElementString("reportsPage.totalEmissions"),
      accessorKey: "co2Emissions",
      size: 100
    }
  ], [gridHeader, dataAttribute]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {t("header", { type: gridHeader })}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <DataTable
            data={data}
            columns={columns}
            containerHeight={data && data.length > 0 ? "620px" : null}
          />
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            {t("buttons.close")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default ReviewDataModal;